import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
export function getCompanyLink(companyID) {
  return companyID ? `${getFullUrl('app')}/contacts/${PortalIdParser.get()}/company/${companyID}` : '';
}